import { getDurationBucket, getSessionDuration } from '../selectors/telemetrySelectors';
import { getTimePanelSource } from '../selectors/timePanelStoreSelectors';
import { addDatapointConfig } from 'owa-analytics-actions';
import { ClientItemId } from 'owa-client-ids';
import { PanelView } from 'owa-time-panel-view-stack';
import { action } from 'satcheljs';
import {
    getTimePanelCustomData,
    timePanelOptions,
    TimePanelTarget,
    TimePanelDeeplinkCustomData,
    TimePanelCloseCustomData,
    TimePanelOpenCustomData,
} from '../datapoints';
import { TimePanelSource } from 'owa-time-panel-bootstrap';

/**
 * Core actions
 */

/**
 * This is the action that is called by openTimePanel orchestrator to update time panel store
 */
export const openTimePanelInternal = action('openTimePanelInternal', (source: TimePanelSource) => ({
    source,
}));

export const initializeTelemetryData = action('initializeTelemetryData');

export const clearTelemetryData = action('clearTelemetryData');

export const panelOpened = action('timePanelOpened', () =>
    addDatapointConfig({
        name: 'timePanelActionOpen',
        options: timePanelOptions,
        customData: getTimePanelCustomData<TimePanelOpenCustomData>({
            // standard logging
            source: getTimePanelSource(),
            // long-term logging
            owa_1: getTimePanelSource(),
        }),
    })
);

export const panelClosed = action('timePanelClosed', () => {
    const sessionDuration = getSessionDuration();
    const sessionDurationBucket = getDurationBucket(sessionDuration);
    return addDatapointConfig({
        name: 'timePanelActionClose',
        options: timePanelOptions,
        customData: getTimePanelCustomData<TimePanelCloseCustomData>({
            // standard logging
            sessionDuration,
            // long-term logging
            owa_1: sessionDurationBucket.lowerBoundMinutes,
            owa_2: sessionDurationBucket.upperBoundMinutes,
        }),
    });
});

export const openDeeplink = action('openDeeplink', (target: TimePanelTarget) =>
    addDatapointConfig({
        name: 'timePanelActionDeeplink',
        options: timePanelOptions,
        customData: getTimePanelCustomData<TimePanelDeeplinkCustomData>({
            // standard logging
            target,
            // long-term logging
            owa_1: target,
        }),
    })
);

export const updateSelectedCalendarEvent = action(
    'updateSelectedCalendarEvent',
    (selectedCalendarEventId: ClientItemId) => ({ selectedCalendarEventId })
);

/**
 * Actions for view stack
 */

export const pushNewView = action('pushNewView', (newView: PanelView) => ({
    newView,
}));

export const updateCurrentView = action('updateCurrentView', (updatedView: PanelView) => ({
    updatedView,
}));

export const resetPanelViewOpenTimeStamp = action('resetPanelViewOpenTimeStamp');
